import * as api from '@/api/api'
import { getDictItemsFromCache } from '@/api/api'
import { isURL } from '@/utils/validate'
import onlineCommons from '@jeecg/antd-online-mini'
import moment from 'moment'
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'
import router from '@/router'

export function timeFix() {
  const time = new Date()
  const hour = time.getHours()
  return hour < 9
    ? '早上好'
    : hour <= 11
    ? '上午好'
    : hour <= 13
    ? '中午好'
    : hour < 20
    ? '下午好'
    : '晚上好'
}

export function welcome() {
  const arr = ['休息一会儿吧', '准备吃什么呢?', '要不要打一把 DOTA', '我猜你可能累了']
  let index = Math.floor(Math.random() * arr.length)
  return arr[index]
}

/**
 * 触发 window.resize
 */
export function triggerWindowResizeEvent() {
  let event = document.createEvent('HTMLEvents')
  event.initEvent('resize', true, true)
  event.eventType = 'message'
  window.dispatchEvent(event)
}

/**
 * 过滤对象中为空的属性
 * @param obj
 * @returns {*}
 */
export function filterObj(obj) {
  if (!(typeof obj == 'object')) {
    return
  }

  for (let key in obj) {
    if (obj.hasOwnProperty(key) && (obj[key] == null || obj[key] == undefined || obj[key] === '')) {
      delete obj[key]
    }
  }
  return obj
}

/**
 * 时间格式化
 * @param value
 * @param fmt
 * @returns {*}
 */
export function formatDate(value, fmt) {
  let regPos = /^\d+(\.\d+)?$/
  if (regPos.test(value)) {
    //如果是数字
    let getDate = new Date(value)
    let o = {
      'M+': getDate.getMonth() + 1,
      'd+': getDate.getDate(),
      'h+': getDate.getHours(),
      'm+': getDate.getMinutes(),
      's+': getDate.getSeconds(),
      'q+': Math.floor((getDate.getMonth() + 3) / 3),
      S: getDate.getMilliseconds(),
    }
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (getDate.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    for (let k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
        )
      }
    }
    return fmt
  } else {
    //TODO
    value = value.trim()
    return value.substr(0, fmt.length)
  }
}

// 生成首页路由
export function generateIndexRouter(data) {
  const defaultPath = data[0]?.children?.[0]?.path || data[0]?.path
  console.log('data[0]', data[0]?.children?.[0]?.path)
  console.log('默认路径：', defaultPath)
  if (!defaultPath) return
  let indexRouter = [
    {
      path: '/',
      name: 'dashboard',
      //component: () => import('@/components/layouts/BasicLayout'),
      component: (resolve) => require(['@/components/layouts/TabLayout'], resolve),
      meta: { title: '首页' },
      // redirect: '/dashboard/analysis',
      redirect: defaultPath,
      children: [...generateChildRouters(data)],
    },
    {
      path: '*',
      redirect: '/404',
      hidden: true,
    },
  ]
  return indexRouter
}

// 生成嵌套路由（子路由）

function generateChildRouters(data) {
  const routers = []
  for (let item of data) {
    let component = ''
    if (item.component.indexOf('layouts') >= 0) {
      component = 'components/' + item.component
    } else {
      component = 'views/' + item.component
    }

    // eslint-disable-next-line
    let URL = (item.meta.url || '').replace(/{{([^}}]+)?}}/g, (s1, s2) => eval(s2)) // URL支持{{ window.xxx }}占位符变量
    if (isURL(URL)) {
      item.meta.url = URL
    }

    let componentPath
    if (item.component == 'components/online/cgform/OnlCgformHeadList') {
      componentPath = onlineCommons.OnlCgformHeadList
    } else if (item.component == 'components/online/cgform/OnlCgformCopyList') {
      componentPath = onlineCommons.OnlCgformCopyList
    } else if (item.component == 'components/online/cgform/auto/OnlCgformAutoList') {
      componentPath = onlineCommons.OnlCgformAutoList
    } else if (item.component == 'components/online/cgform/auto/OnlCgformTreeList') {
      componentPath = onlineCommons.OnlCgformTreeList
    } else if (item.component == 'components/online/cgform/auto/erp/OnlCgformErpList') {
      componentPath = onlineCommons.OnlCgformErpList
    } else if (
      item.component == 'components/online/cgform/auto/innerTable/OnlCgformInnerTableList'
    ) {
      componentPath = onlineCommons.OnlCgformInnerTableList
    } else if (item.component == 'components/online/cgreport/OnlCgreportHeadList') {
      componentPath = onlineCommons.OnlCgreportHeadList
    } else if (item.component == 'components/online/cgreport/auto/OnlCgreportAutoList') {
      componentPath = onlineCommons.OnlCgreportAutoList
    } else {
      componentPath = (resolve) => require(['@/' + component + '.vue'], resolve)
    }

    let menu = {
      path: item.path,
      name: item.name,
      redirect: item.redirect,
      component: componentPath,
      hidden: item.hidden,
      //component:()=> import(`@/views/${item.component}.vue`),
      meta: {
        title: item.meta.title,
        icon: item.meta.icon,
        url: item.meta.url,
        permissionList: item.meta.permissionList,
        keepAlive: item.meta.keepAlive,
        /*update_begin author:wuxianquan date:20190908 for:赋值 */
        internalOrExternal: item.meta.internalOrExternal,
        /*update_end author:wuxianquan date:20190908 for:赋值 */
      },
    }
    if (item.alwaysShow) {
      menu.alwaysShow = true
      menu.redirect = menu.path
    }
    if (item.children && item.children.length > 0) {
      menu.children = [...generateChildRouters(item.children)]
    }
    //--update-begin----author:scott---date:20190320------for:根据后台菜单配置，判断是否路由菜单字段，动态选择是否生成路由（为了支持参数URL菜单）------
    //判断是否生成路由
    if (item.route && item.route === '0') {
      //console.log(' 不生成路由 item.route：  '+item.route);
      //console.log(' 不生成路由 item.path：  '+item.path);
    } else {
      routers.push(menu)
    }
    //--update-end----author:scott---date:20190320------for:根据后台菜单配置，判断是否路由菜单字段，动态选择是否生成路由（为了支持参数URL菜单）------
  }
  return routers
}

/**
 * 深度克隆对象、数组
 * @param obj 被克隆的对象
 * @return 克隆后的对象
 */
export function cloneObject(obj) {
  return JSON.parse(JSON.stringify(obj))
}

/**
 * 随机生成数字
 *
 * 示例：生成长度为 12 的随机数：randomNumber(12)
 * 示例：生成 3~23 之间的随机数：randomNumber(3, 23)
 *
 * @param1 最小值 | 长度
 * @param2 最大值
 * @return int 生成后的数字
 */
export function randomNumber() {
  // 生成 最小值 到 最大值 区间的随机数
  const random = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1) + min)
  }
  if (arguments.length === 1) {
    let [length] = arguments
    // 生成指定长度的随机数字，首位一定不是 0
    let nums = [...Array(length).keys()].map((i) => (i > 0 ? random(0, 9) : random(1, 9)))
    return parseInt(nums.join(''))
  } else if (arguments.length >= 2) {
    let [min, max] = arguments
    return random(min, max)
  } else {
    return Number.NaN
  }
}

/**
 * 随机生成字符串
 * @param length 字符串的长度
 * @param chats 可选字符串区间（只会生成传入的字符串中的字符）
 * @return string 生成的字符串
 */
export function randomString(length, chats) {
  if (!length) length = 1
  if (!chats) chats = '0123456789qwertyuioplkjhgfdsazxcvbnm'
  let str = ''
  for (let i = 0; i < length; i++) {
    let num = randomNumber(0, chats.length - 1)
    str += chats[num]
  }
  return str
}

/**
 * 随机生成uuid
 * @return string 生成的uuid
 */
export function randomUUID() {
  let chats = '0123456789abcdef'
  return randomString(32, chats)
}

/**
 * 下划线转驼峰
 * @param string
 * @returns {*}
 */
export function underLine2CamelCase(string) {
  return string.replace(/_([a-z])/g, function (all, letter) {
    return letter.toUpperCase()
  })
}

/**
 * 判断是否显示办理按钮
 * @param bpmStatus
 * @returns {*}
 */
export function showDealBtn(bpmStatus) {
  if (bpmStatus != '1' && bpmStatus != '3' && bpmStatus != '4') {
    return true
  }
  return false
}

/**
 * 增强CSS，可以在页面上输出全局css
 * @param css 要增强的css
 * @param id style标签的id，可以用来清除旧样式
 */
export function cssExpand(css, id) {
  let style = document.createElement('style')
  style.type = 'text/css'
  style.innerHTML = `@charset "UTF-8"; ${css}`
  // 清除旧样式
  if (id) {
    let $style = document.getElementById(id)
    if ($style != null) $style.outerHTML = ''
    style.id = id
  }
  // 应用新样式
  document.head.appendChild(style)
}

/** 用于js增强事件，运行JS代码，可以传参 */
// options 所需参数：
//    参数名         类型            说明
//    vm             VueComponent    vue实例
//    event          Object          event对象
//    jsCode         String          待执行的js代码
//    errorMessage   String          执行出错后的提示（控制台）
export function jsExpand(options = {}) {
  // 绑定到window上的keyName
  let windowKeyName = 'J_CLICK_EVENT_OPTIONS'
  if (typeof window[windowKeyName] != 'object') {
    window[windowKeyName] = {}
  }

  // 随机生成JS增强的执行id，防止冲突
  let id = randomString(16, 'qwertyuioplkjhgfdsazxcvbnm'.toUpperCase())
  // 封装按钮点击事件
  let code = `
    (function (o_${id}) {
      try {
        (function (globalEvent, vm) {
          ${options.jsCode}
        })(o_${id}.event, o_${id}.vm)
      } catch (e) {
        o_${id}.error(e)
      }
      o_${id}.done()
    })(window['${windowKeyName}']['EVENT_${id}'])
  `
  // 创建script标签
  const script = document.createElement('script')
  // 将需要传递的参数挂载到window对象上
  window[windowKeyName]['EVENT_' + id] = {
    vm: options.vm,
    event: options.event,
    // 当执行完成时，无论如何都会调用的回调事件
    done() {
      // 执行完后删除新增的 script 标签不会撤销执行结果（已产生的结果不会被撤销）
      script.outerHTML = ''
      delete window[windowKeyName]['EVENT_' + id]
    },
    // 当js运行出错的时候调用的事件
    error(e) {
      console.group(`${options.errorMessage || '用户自定义JS增强代码运行出错'}（${new Date()}）`)
      console.error(e)
      console.groupEnd()
    },
  }
  // 将事件挂载到document中
  script.innerHTML = code
  document.body.appendChild(script)
}

/**
 * 重复值验证工具方法
 *
 * 使用示例：
 * { validator: (rule, value, callback) => validateDuplicateValue('sys_fill_rule', 'rule_code', value, this.model.id, callback) }
 *
 * @param tableName 被验证的表名
 * @param fieldName 被验证的字段名
 * @param fieldVal 被验证的值
 * @param dataId 数据ID，可空
 * @param callback
 */
export function validateDuplicateValue(tableName, fieldName, fieldVal, dataId, callback) {
  if (fieldVal) {
    let params = { tableName, fieldName, fieldVal, dataId }
    api
      .duplicateCheck(params)
      .then((res) => {
        res['success'] ? callback() : callback(res['message'])
      })
      .catch((err) => {
        callback(err.message || err)
      })
  } else {
    callback()
  }
}

/**
 * 根据编码校验规则code，校验传入的值是否合法
 *
 * 使用示例：
 * { validator: (rule, value, callback) => validateCheckRule('common', value, callback) }
 *
 * @param ruleCode 编码校验规则 code
 * @param value 被验证的值
 * @param callback
 */
export function validateCheckRule(ruleCode, value, callback) {
  if (ruleCode && value) {
    value = encodeURIComponent(value)
    api
      .checkRuleByCode({ ruleCode, value })
      .then((res) => {
        res['success'] ? callback() : callback(res['message'])
      })
      .catch((err) => {
        callback(err.message || err)
      })
  } else {
    callback()
  }
}

/**
 * 如果值不存在就 push 进数组，反之不处理
 * @param array 要操作的数据
 * @param value 要添加的值
 * @param key 可空，如果比较的是对象，可能存在地址不一样但值实际上是一样的情况，可以传此字段判断对象中唯一的字段，例如 id。不传则直接比较实际值
 * @returns {boolean} 成功 push 返回 true，不处理返回 false
 */
export function pushIfNotExist(array, value, key) {
  for (let item of array) {
    if (key && item[key] === value[key]) {
      return false
    } else if (item === value) {
      return false
    }
  }
  array.push(value)
  return true
}

/**
 * 可用于判断是否成功
 * @type {symbol}
 */
export const succeedSymbol = Symbol()
/**
 * 可用于判断是否失败
 * @type {symbol}
 */
export const failedSymbol = Symbol()

/**
 * 使 promise 无论如何都会 resolve，除非传入的参数不是一个Promise对象或返回Promise对象的方法
 * 一般用在 Promise.all 中
 *
 * @param promise 可传Promise对象或返回Promise对象的方法
 * @returns {Promise<any>}
 */
export function alwaysResolve(promise) {
  return new Promise((resolve, reject) => {
    let p = promise
    if (typeof promise === 'function') {
      p = promise()
    }
    if (p instanceof Promise) {
      p.then((data) => {
        resolve({ type: succeedSymbol, data })
      }).catch((error) => {
        resolve({ type: failedSymbol, error })
      })
    } else {
      reject('alwaysResolve: 传入的参数不是一个Promise对象或返回Promise对象的方法')
    }
  })
}

/**
 * 简单实现防抖方法
 *
 * 防抖(debounce)函数在第一次触发给定的函数时，不立即执行函数，而是给出一个期限值(delay)，比如100ms。
 * 如果100ms内再次执行函数，就重新开始计时，直到计时结束后再真正执行函数。
 * 这样做的好处是如果短时间内大量触发同一事件，只会执行一次函数。
 *
 * @param fn 要防抖的函数
 * @param delay 防抖的毫秒数
 * @returns {Function}
 */
export function simpleDebounce(fn, delay = 100) {
  let timer = null
  return function () {
    let args = arguments
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(() => {
      fn.apply(this, args)
    }, delay)
  }
}

/**
 * 不用正则的方式替换所有值
 * @param text 被替换的字符串
 * @param checker  替换前的内容
 * @param replacer 替换后的内容
 * @returns {String} 替换后的字符串
 */
export function replaceAll(text, checker, replacer) {
  let lastText = text
  text = text.replace(checker, replacer)
  if (lastText !== text) {
    return replaceAll(text, checker, replacer)
  }
  return text
}

/**
 * 获取事件冒泡路径，兼容 IE11，Edge，Chrome，Firefox，Safari
 * 目前使用的地方：JEditableTable Span模式
 */
export function getEventPath(event) {
  let target = event.target
  let path = (event.composedPath && event.composedPath()) || event.path

  if (path != null) {
    return path.indexOf(window) < 0 ? path.concat(window) : path
  }

  if (target === window) {
    return [window]
  }

  let getParents = (node, memo) => {
    memo = memo || []
    const parentNode = node.parentNode

    if (!parentNode) {
      return memo
    } else {
      return getParents(parentNode, memo.concat(parentNode))
    }
  }
  return [target].concat(getParents(target), window)
}

/**
 * 根据组件名获取父级
 * @param vm
 * @param name
 * @returns {Vue | null|null|Vue}
 */
export function getVmParentByName(vm, name) {
  let parent = vm.$parent
  if (parent && parent.$options) {
    if (parent.$options.name === name) {
      return parent
    } else {
      let res = getVmParentByName(parent, name)
      if (res) {
        return res
      }
    }
  }
  return null
}

/**
 * 使一个值永远不会为（null | undefined）
 *
 * @param value 要处理的值
 * @param def 默认值，如果value为（null | undefined）则返回的默认值，可不传，默认为''
 */
export function neverNull(value, def) {
  return value == null ? neverNull(def, '') : value
}

/**
 * 生成随机十六进制颜色值
 */
export function randomColor() {
  let color = '#'
  for (let i = 0; i < 6; i++) {
    color += Math.floor(Math.random() * 16).toString(16)
  }
  return color
}

/**
 * 处理折线图结构数据
 * @param data 原始数据
 */
export function handleLineChartData(data) {
  // x轴数据
  const xData =
    data && data.length
      ? [...new Set(data.map((item) => moment(item.create_time).format('YYYY-MM-DD')))]
      : []
  // 显示图例
  const filedList = data && data.length ? [...new Set(data.map((item) => item.name))] : []

  // 渲染数据
  const lineData = []
  xData.forEach((xTime, index) => {
    data.forEach((item) => {
      if (moment(item.create_time).format('YYYY-MM-DD') === xTime) {
        const catchData = {
          type: xTime,
          [item.name]: item.value || 0,
          [item.name + 'id']: item.id,
          [item.name + 'periodId']: item.periodId,
          [item.name + 'incident']: item?.incident || '0',
          [item.name + 'realtime']: item?.realtime || '',
          [item.name + 'picStatus']: item?.picStatus || 0,
        }
        lineData[index] = lineData[index] ? { ...lineData[index], ...catchData } : catchData
      }
    })
  })
  return { xData, filedList, lineData }
}

/**
 * 折线图添加对比
 * @param data 原始数据
 * @param filed 显示图例字段
 * @param compareData 对比数据
 * @returns {lineData: Array, filedList: Array} 叠加后的折线数据和图例字段
 */
export function addLineCompare(data, filed, compareData) {
  console.log('对比数据：', compareData)

  const lineData = [...data]
  const filedList = [...filed]
  lineData.forEach((item) => {
    compareData.forEach((item1) => {
      if (item.type === moment(item1.create_time).format('YYYY-MM-DD')) {
        item[item1.name] = item1.value || 0
        item[item1.name + 'id'] = item1.id
        item[item1.name + 'incident'] = item1?.incident || '0'
        item[item1.name + 'periodId'] = item1.periodId
        item[item1.name + 'realtime'] = item1.realtime
        item[item1.name + 'picStatus'] = item1?.picStatus || 0
        if (!filedList.includes(item1.name)) {
          filedList.push(item1.name)
        }
      }
    })
  })
  return { lineData, filedList }
}

/**
 * 删除对应的对比数据
 * @param data 原始数据
 * @param filed 去除相关字段
 * @returns {Array} 删除对比数据后的这项数据
 */
export function deleteLineCompare(data, filed) {
  if (!data.length) return []
  const isNotHasFieldId = data.every((item) => item[filed + 'id'] == undefined)
  // 如果都不包含filedId，则直接返回原数组，否则需要删除相关字段
  if (isNotHasFieldId) return data
  let lineData = [...data]
  lineData = lineData.map((item) => removeObjKey(item, filed))
  return lineData
}

/**
 * 去除对象中某个属性
 * @param obj 要处理的对象
 * @param field 要删除的属性名
 */
export function removeObjKey(obj, field) {
  const newObj = Object.keys(obj).reduce((acc, key) => {
    if (
      key != field &&
      key != field + 'id' &&
      key != field + 'periodId' &&
      key != field + 'incident' &&
      key != field + 'realtime' &&
      key != field + 'picStatus'
    ) {
      acc[key] = obj[key]
    }
    return acc
  }, {})
  return newObj
}

/**
 *保留某个字段的数组
 * @param {Array} data 原数组
 * @param {Array} fields 需要保留的字段
 */
export function saveFieldsArrKey(data, fields, joinKeys = ['id', 'incident']) {
  // 需要映射的key
  const keepKeys = ['type', ...fields]
  fields.forEach((item) => {
    joinKeys.forEach((key) => {
      if (key) {
        keepKeys.push(item + key)
      }
    })
  })
  const saveArr = []
  data.forEach((item) => {
    const obj = {}
    keepKeys.forEach((key) => {
      if (key != undefined && item[key] !== undefined) {
        obj[key] = item[key]
      }
    })
    saveArr.push(obj)
  })

  return saveArr
}

/**
 * 将数组对象中包含某个字符串的字段过滤出来，主要出需要标注的位置
 * @param {Array} data 原数组
 * @param {String} str 字符串
 * @param {Number} status 状态
 * @returns {Array} 过滤后的数组
 */
export function mapArrFiledKey(data) {
  try {
    const keys = Object.keys(data[0]).filter(
      (key) => key.includes('incident') || key.includes('warn')
    )
    // console.log('包含incident或warn的字段--', keys)
    const groundArrObj = strToGroup(keys)
    // console.log('分组对象--', groundArrObj)
    const moreEvList = []
    const incidentList = []
    const warnList = []
    if (keys.length) {
      data.forEach((item) => {
        groundArrObj.forEach((obj) => {
          const position = [item.type, item[obj.field]]
          const id = item[obj.field + 'id']
          if (item[obj.incident] == 1 && item[obj.warn] == 1) {
            moreEvList.push({ position, id })
          } else if (item[obj.incident] == 1) {
            incidentList.push({ position, id })
          } else if (item[obj.warn] == 1) {
            warnList.push({ position, id })
          }
        })
      })
    }
    return { moreEvList, incidentList, warnList }
  } catch (error) {
    console.log('错误信息--', error)
  }
}

export function strToGroup(strArr) {
  const groupedArray = []

  // 创建一个对象来存储分组
  const groupMap = {}

  strArr.forEach((str) => {
    const key = str.replace(/incident|warn/, '')

    if (!groupMap[key]) {
      groupMap[key] = { incident: '', warn: '' }
    }
    if (str.includes('incident')) {
      groupMap[key].incident = str
    } else if (str.includes('warn')) {
      groupMap[key].warn = str
    }
    groupMap[key].field = key
  })
  // 将对象转换为数组数组格式
  for (const group in groupMap) {
    groupedArray.push(groupMap[group])
  }
  return groupedArray
}

/**
 *
 * @param {String} dateStr
 * @returns
 */
export function isValidDate(dateStr) {
  // 定义可能的日期格式
  const formats = ['YYYY-MM-DD', 'YYYY/MM/DD', 'YYYY-MM-DD HH:mm:ss', 'YYYY/MM/DD HH:mm:ss']
  // 遍历格式数组，检查是否有效
  return formats.some((format) => moment(dateStr, format, true).isValid())
}

/**
 * 根据时间进行排序
 * @param {Array} arrObj 原对象数组
 * @param {String} filed 排序字段
 * @param {String} type 升序或降序
 */
export function sortArrObj(arrObj, filed = 'time', type = 'asc') {
  arrObj.sort((a, b) => {
    const dateA = moment(a[filed])
    const dateB = moment(b[filed])

    // 检查日期的有效性
    if (!dateA.isValid() && !dateB.isValid()) return 0 // 都无效，保持当前顺序
    if (!dateA.isValid()) return 1 // a 无效，置于后面
    if (!dateB.isValid()) return -1 // b 无效，置于后面

    // 根据类型进行排序，升序或降序
    return type === 'asc'
      ? dateA.valueOf() - dateB.valueOf() // 升序
      : dateB.valueOf() - dateA.valueOf() // 降序
  })

  return arrObj
}

/**
 * 根据数组对象中某一个属性数值进行排序
 * @param {Array} arrObj 原对象数组
 * @param {String} filed 排序字段
 * @param {String} type 升序或降序
 */
export function sortArrObjByNum(arrObj, filed = 'num', type = 'ascend', otherFiled = 'index') {
  arrObj.sort((a, b) => {
    if (Array.isArray(otherFiled)) {
      otherFiled.forEach((key) => {
        if (a[filed] == b[filed]) {
          return type.includes('asc') ? a[key] - b[key] : b[key] - a[key] // 升序排序
        }
      })
    }
    if (a[filed] == b[filed] && otherFiled) {
      return type.includes('asc') ? b[otherFiled] - a[otherFiled] : a[otherFiled] - b[otherFiled] // 升序排序
    }
    return type.includes('asc') ? a[filed] - b[filed] : b[filed] - a[filed] // 升序排序
  })
  return arrObj
}

/**
 *
 * @param {dom} element ref实例对象
 * @param {String} filename 保存文件名
 */
export function exportToPdf(element, filename) {
  // const element = this.$refs.exportContent
  // 使用html2canvas将内容转换为PNG图片
  html2canvas(element, {
    useCORS: true, // 允许使用跨域图像
  }).then((canvas) => {
    const imgData = canvas.toDataURL('image/jpeg')

    // 创建一个新的jsPDF实例
    const pdf = new jsPDF()
    const imgWidth = 210 - 20 // A4页面宽度减去左右内边距（20mm）
    const pageHeight = pdf.internal.pageSize.height // 获取PDF页面高度

    const imgHeight = (canvas.height * imgWidth) / canvas.width // 根据比例计算图片高度
    let heightLeft = imgHeight // 剩余高度
    let position = 10 // 初始位置（顶部内边距10mm）

    // 分页处理
    while (heightLeft >= 0) {
      pdf.addImage(imgData, 'JPEG', 10, position, imgWidth, imgHeight) // 左右各10mm内边距
      heightLeft -= pageHeight // 减去页面高度
      position -= pageHeight // 移动位置至下一页
      if (heightLeft >= 0) {
        pdf.addPage() // 需要新页面时，添加新页面
      }
    }
    // 保存PDF文件
    pdf.save(`${filename}.pdf`)
  })
}

/**
 * 回显图片
 * @param {String} url 图片下载地址
 */
export const getStoreHttpUrl = (url) => {
  return window._CONFIG['resourceURL'] + '/school/sys/common/downloadSlice?filename=' + url
}

/**
 * 获取文件下载地址
 * @param {String} url 文件下载地址
 * @returns {string}
 */
export const getStoreFileUrl = (url) => {
  return window._CONFIG['resourceURL'] + '/school/sys/common/static' + url
}

/**
 * 下载文件
 * @param {String} url 文件下载地址
 * @param {String} fileName 文件名
 */
export const downloadFile = (url, fileName = '') => {
  // 直接下载文件
  const fileUrl = getStoreFileUrl(url)
  if (!fileName) {
    const a = document.createElement('a')
    a.href = fileUrl
    a.setAttribute('download', '') // 自定义下载文件的名称
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    return
  }
  // 重命名下载文件
  const lastDotIndex = fileUrl.lastIndexOf('.')
  const fileExtension = fileUrl.substring(lastDotIndex + 1)
  getBlob(fileUrl).then((blob) => {
    saveAs(blob, fileName + '.' + fileExtension)
  })
}

const getBlob = (url) => {
  return new Promise((resolve) => {
    const xhr = new XMLHttpRequest()
    xhr.open('GET', url, true)
    xhr.responseType = 'blob'
    xhr.onload = () => {
      if (xhr.status === 200) {
        resolve(xhr.response)
      }
    }
    xhr.send()
  })
}
const saveAs = (blob, filename) => {
  const link = document.createElement('a')
  link.href = window.URL.createObjectURL(blob)
  link.download = filename
  link.click()
}

/**
 * @param {String} dictCode 字典标识
 * @param {String} key 字典值
 * @param {Boolean} isText 是否返回文本
 */
export const getDictCodeData = (dictCode, key, isText = false) => {
  if (!dictCode) return
  //优先从缓存中读取字典配置
  if (!getDictItemsFromCache(dictCode)) return {}
  const dictOptions = getDictItemsFromCache(dictCode)
  const keyArr = key?.split?.(',')
  if (keyArr?.length && keyArr?.length > 1) {
    let record = dictOptions.filter((item) => keyArr.includes(item.value))
    if (isText) {
      record = record.map((item) => item.text).join('、')
    }
    return record
  } else if (key !== undefined) {
    let record = dictOptions?.find((item) => item.value == key) || {
      text: '',
      title: '',
      value: '',
    }
    // console.log('记录：', record)
    if (isText) {
      return record.text || '-'
    }
    return record
  }
  return dictOptions
  //根据字典Code, 初始化字典数组
  // const res = ajaxGetDictItems(this.dictCode, null)
  // if (res.success) {
  //   dictOptions = res.result
  // }
  // console.log('封装字典数据：', dictOptions)
}

/**
 * 根据数组对象中某一个属性数值进行分类
 * @param data 原数组
 * @param filed 分类字段
 * @param children 节点字段名称
 * @returns {Array} 分类后的数组
 */
export const sortFlatToTree = (data, filed = 'sort', children = 'children') => {
  if (!data || !Array.isArray(data) || !filed || !children) return []
  // 创建一个对象来存储分组后的结果
  const groupedData = {}

  // 遍历数据，根据 sort 字段进行分组
  data.forEach((item) => {
    if (!groupedData[item[filed]]) {
      groupedData[item[filed]] = []
    }
    groupedData[item[filed]].push(item)
  })

  // 将分组后的数据转换为树形结构
  return Object.keys(groupedData).map((sortKey) => ({
    [filed]: sortKey,
    [children]: groupedData[sortKey],
  }))
}

/**
 * 获取某一个年的开始和结束时间 2025 -> [2025-01-01, 2025-12-31]
 * @param year
 * @returns {Array}
 */
export const getYearStarting = (year) => {
  const currYear = Number(year)
  const startOfYear = moment([currYear]).format('YYYY-MM-DD')
  const endOfYear = moment([currYear]).endOf('year').format('YYYY-MM-DD')
  return [startOfYear, endOfYear]
}

/*
 * 格式化日期(moment格式、普通格式)
 * @param {Date} date 日期
 * @param {String} str 格式化字符串
 */
export const formatMomentDate = (date, str = 'YYYY-MM-DD') => {
  return date && moment(date).format(str)
}

/**
 * 获取当前时间戳-秒钟/毫秒, 0为秒钟，1为毫秒
 * @param type 类型 0为秒钟，1为毫秒
 * @returns {number}
 */
export const getNowTime = (type = '0') => {
  return type === '0' ? moment().unix() : moment().valueOf()
}

// 秒钟转为00:00:00格式
export const formatSeconds = (seconds) => {
  const h = Math.floor(seconds / 3600)
  const m = Math.floor((seconds % 3600) / 60)
  const s = Math.floor(seconds % 60)
  return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s
    .toString()
    .padStart(2, '0')}`
}

export const getDateRange = (days) => {
  let beginDate, endDate
  if (days < 0) {
    // 获取过去的时间范围
    beginDate = moment().subtract(Math.abs(days), 'days')
    endDate = moment()
  } else {
    // 获取未来的时间范围
    beginDate = moment()
    endDate = moment().add(days, 'days')
  }
  return {
    beginDate: beginDate.format('YYYY-MM-DD'),
    endDate: endDate.format('YYYY-MM-DD'),
  }
}

/**
 * 获取文件后缀名
 * @param filePath 文件路径
 * @returns {*}
 */
export const getFileSuffix = (filePath) => {
  const arr = filePath.split('.')
  return arr[arr.length - 1]
}

/**
 * 提取文字中的字母
 * @param str
 * @returns {*}
 */
export const extractLetters = (str) => {
  let lettersArray = str.match(/[a-zA-Z]/g)
  return lettersArray.join('')
}

/**
 * 传入日期是否大于今天日期
 * @param date
 * @returns {boolean}
 */
export const isDateGreaterThanToday = (date) => {
  const today = moment().format('YYYY-MM-DD')
  const dateStr = moment(date).format('YYYY-MM-DD')
  return moment(dateStr).isAfter(today)
}

/**moment
 * @param date1 日期1
 * @param date2 日期2
 * @returns {number}
 */
export const getDateDiff = (date1, date2) => {
  const diff = moment(date2).diff(moment(date1), 'days')
  return diff
}

/**
 * 复制文本
 * @param text 文本
 * @param cbSuccess 成功回调
 * @param cbError 失败回调
 */
export const copyText = (text, cbSuccess, cbError) => {
  // 使用 兼容方案 复制文本
  try {
    // 创建临时输入框
    const input = document.createElement('input')
    input.setAttribute('readonly', 'readonly') // 设置为只读防止手机上弹出软键盘
    input.value = text
    document.body.appendChild(input)

    // 选中并复制
    input.select()
    input.setSelectionRange(0, 9999) // 兼容移动端
    document.execCommand('copy')

    // 移除临时输入框
    document.body.removeChild(input)
    cbSuccess && cbSuccess()
  } catch (err) {
    cbError && cbError(err)
  }
}

/**
 * 计算分类数组中对应另一个数组字段的平均值和总值
 * @param arr 数组
 * @param field 字段
 * @param type 计算类型 avg:平均值 sum:总和，all:全部数据，默认为平均值
 */
export const getGroupAvgOrSum = (arr, fields, type = 'avg') => {
  const monthlyStats = Object.entries(arr).map(([month, items]) => {
    const stats = { month }
    fields.forEach((field) => {
      const sum = items.reduce((total, item) => total + item[field], 0)
      const avg = sum / items.length
      switch (type) {
        case 'avg':
          stats[`${field}平均值`] = avg.toFixed(2) // 平均值，保留2位小数
          break
        case 'sum':
          stats[`${field}总值`] = sum.toFixed(2) // 总和，保留2位小数
          break
        case 'all':
          stats[`${field}总值`] = sum.toFixed(2) // 总和，保留2位小数
          stats[`${field}平均值`] = avg.toFixed(2) // 平均值，保留2位小数
          break
      }
    })
    return stats
  })
  return monthlyStats
}

/**
 * 打开跳转路由并打开新标签页
 * @param data
 */
export const openNewTabPage = (data) => {
  const route = router.resolve(data)
  // 打开新标签页
  window.open(route.href, '_blank')
}

/**
 * 改变浏览器标签页图标
 * @param {*} url 图标地址
 */
// changeFavicon('/new-favicon.ico');
export const changeFavicon = (url) => {
  let link = document.querySelector("link[rel*='icon']") || document.createElement('link')
  link.type = 'image/x-icon'
  link.rel = 'shortcut icon'
  link.href = url
  document.getElementsByTagName('head')[0].appendChild(link)
}

/**
 * 获取学生标签颜色配置
 * @param {*} key
 * @returns {color, bgColor}
 */
export const getStuTagColorConfig = (key) => {
  return {
    care: {
      color: '#35A7FA',
      bgColor: '#EFF4FF',
    },
    semesterWarnNum: {
      color: '#F87654',
      bgColor: '#FFF4F1',
    },
    tags: {
      color: '#6188FA',
      bgColor: '#EFF4FF',
    },
    consecutiveWarningWeeks: {
      color: '#F87654',
      bgColor: '#FFF4F1',
    },
  }[key]
}

/**
 * 深拷贝
 * @param {*} obj  要拷贝的对象
 * @param {*} hash  用于存储循环引用的 WeakMap
 * @returns
 */
export function deepClone(obj, hash = new WeakMap()) {
  // 如果是 null 或者不是对象/数组，直接返回
  if (obj === null || typeof obj !== 'object') {
    return obj
  }

  // 如果是日期对象，返回新的日期对象
  if (obj instanceof Date) {
    return new Date(obj)
  }

  // 如果是正则表达式，返回新的正则表达式
  if (obj instanceof RegExp) {
    return new RegExp(obj)
  }

  // 如果已经存在循环引用，直接返回
  if (hash.has(obj)) {
    return hash.get(obj)
  }

  // 创建一个新的对象或数组
  let cloneObj = Array.isArray(obj) ? [] : {}

  // 将当前对象存储到 hash 中，防止循环引用
  hash.set(obj, cloneObj)

  // 遍历对象的所有属性并递归克隆
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      cloneObj[key] = deepClone(obj[key], hash)
    }
  }

  return cloneObj
}
